/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.6.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as runtime from '../runtime';
import { ChangeInOutStatusCommandToJSON, DeleteUserCustomFilterCommandToJSON, ModifyProfileRequestToJSON, SaveUserCustomFilterCommandToJSON, StartLaborTimerCommandToJSON, StopLaborTimerCommandToJSON, UserFromJSON, UserCreateCommandToJSON, } from '../models';
/**
 *
 */
var UsersApi = /** @class */ (function (_super) {
    __extends(UsersApi, _super);
    function UsersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     */
    UsersApi.prototype.changeStatusRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Users/ChangeStatus",
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: ChangeInOutStatusCommandToJSON(requestParameters.changeInOutStatusCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return UserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    UsersApi.prototype.changeStatus = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.changeStatusRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    UsersApi.prototype.createUserRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Users",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: UserCreateCommandToJSON(requestParameters.userCreateCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return UserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    UsersApi.prototype.createUser = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createUserRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    UsersApi.prototype.deleteCustomFilterRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Users/DeleteCustomFilter",
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: DeleteUserCustomFilterCommandToJSON(requestParameters.deleteUserCustomFilterCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return UserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    UsersApi.prototype.deleteCustomFilter = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteCustomFilterRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    UsersApi.prototype.getMyProfileRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Users/MyProfile",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return UserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    UsersApi.prototype.getMyProfile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMyProfileRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    UsersApi.prototype.getUserRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.userId === null || requestParameters.userId === undefined) {
                            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling getUser.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Users/{userId}".replace("{" + "userId" + "}", encodeURIComponent(String(requestParameters.userId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return UserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    UsersApi.prototype.getUser = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUserRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    UsersApi.prototype.putMyProfileRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Users/MyProfile",
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: ModifyProfileRequestToJSON(requestParameters.modifyProfileRequest),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return UserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    UsersApi.prototype.putMyProfile = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.putMyProfileRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    UsersApi.prototype.queryUsersRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.userId !== undefined) {
                            queryParameters['UserId'] = requestParameters.userId;
                        }
                        if (requestParameters.skip !== undefined) {
                            queryParameters['Skip'] = requestParameters.skip;
                        }
                        if (requestParameters.take !== undefined) {
                            queryParameters['Take'] = requestParameters.take;
                        }
                        if (requestParameters.localAccountFlag !== undefined) {
                            queryParameters['LocalAccountFlag'] = requestParameters.localAccountFlag;
                        }
                        if (requestParameters.mustChangePasswordNextLogon !== undefined) {
                            queryParameters['MustChangePasswordNextLogon'] = requestParameters.mustChangePasswordNextLogon;
                        }
                        if (requestParameters.cannotChangePassword !== undefined) {
                            queryParameters['CannotChangePassword'] = requestParameters.cannotChangePassword;
                        }
                        if (requestParameters.isDisabled !== undefined) {
                            queryParameters['IsDisabled'] = requestParameters.isDisabled;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Users",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(UserFromJSON); })];
                }
            });
        });
    };
    /**
     */
    UsersApi.prototype.queryUsers = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.queryUsersRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    UsersApi.prototype.saveCustomFilterRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Users/SaveCustomFilter",
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: SaveUserCustomFilterCommandToJSON(requestParameters.saveUserCustomFilterCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return UserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    UsersApi.prototype.saveCustomFilter = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.saveCustomFilterRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    UsersApi.prototype.startLaborTimerRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Users/my/timers/start",
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: StartLaborTimerCommandToJSON(requestParameters.startLaborTimerCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return UserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    UsersApi.prototype.startLaborTimer = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.startLaborTimerRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    UsersApi.prototype.stopLaborTimerRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Users/my/timers/stop",
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: StopLaborTimerCommandToJSON(requestParameters.stopLaborTimerCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return UserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    UsersApi.prototype.stopLaborTimer = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stopLaborTimerRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return UsersApi;
}(runtime.BaseAPI));
export { UsersApi };
